export default __webpack_public_path__ + "static/logo-duta-pertiwi-white-337f91be96df76ce444a7af30ac2d310.svg";